<router-outlet class="h-100 p-0 m-0"></router-outlet>
